import { createFileRoute } from '@tanstack/react-router';
import { canShowExtratoTemporario } from '@/features/login/util';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/extrato-boleto')({
    beforeLoad: () =>
        validateRoute({
            condition: canShowExtratoTemporario([1, 3]),
            fintech: true,
            validatePermission: ({ upp_fintech_administrativo }) =>
                isPermissionFull(upp_fintech_administrativo),
        }),
});
